export const getTabs = (): { label: string; name: string }[] => {
  return [
    { label: "Wszystkie", name: "all" },
    { label: "W drodze", name: "departed" },
    { label: "Aktywne", name: "active" },
  ];
};
